import moment from 'moment';

import {
  PCM_ORDER_STATUS,
  PURCHASED_CUSTOM_PRINT_STATUS,
} from '../constants/custom-prints';

export const getOrderStatusLabel = ({ accountCard, purchasedCustomPrint }) => {
  let status;
  let updatedAt;

  if (accountCard) {
    const { purchased_custom_print_account_card: purchasedCard } = accountCard;
    status = purchasedCard?.pcm_order_status;
    updatedAt = purchasedCard?.pcm_order_status_updated_at;
  } else if (purchasedCustomPrint?.waldogram) {
    status =
      purchasedCustomPrint.waldogram?.pcm_order_status ??
      purchasedCustomPrint.order_status;
    updatedAt = purchasedCustomPrint.waldogram?.pcm_order_status_updated_at;
  } else if (purchasedCustomPrint.order_status) {
    status = purchasedCustomPrint.order_status;
  }

  if (status === PCM_ORDER_STATUS.MAILING) {
    return 'Pending shipping';
  }

  if (status === PURCHASED_CUSTOM_PRINT_STATUS.PENDING) {
    return 'Pending processing';
  }

  if (
    [
      PCM_ORDER_STATUS.DELIVERED,
      PURCHASED_CUSTOM_PRINT_STATUS.SHIPPED,
    ].includes(status) &&
    updatedAt
  ) {
    return `Shipped on: ${moment(updatedAt)
      .format('DD MMMM YYYY')
      .toUpperCase()}`;
  }
  if (
    [
      PCM_ORDER_STATUS.DELIVERED,
      PURCHASED_CUSTOM_PRINT_STATUS.SHIPPED,
    ].includes(status)
  ) {
    return 'Shipped';
  }

  return '';
};
